import React from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';

class BreakpointChange extends React.Component {
  onBreakpointChange = () => {
    this.props.onChange(MediaQuery.current);
  };

  componentDidMount() {
    $(window).on('changed.zf.mediaquery', this.onBreakpointChange);
    this.onBreakpointChange();
  }

  componentWillUnmount() {
    $(window).off('changed.zf.mediaquery', this.onBreakpointChange);
  }

  render() {
    return null;
  }
}

BreakpointChange.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default BreakpointChange;
